// extracted by mini-css-extract-plugin
export default {"SignUp":"SignUp_SignUp__UT3n5","Border":"SignUp_Border__uE4oX","InputClass":"SignUp_InputClass__dlTXT","Button":"SignUp_Button__PMryR"};